var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePomegranate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#E8B4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4868 33.9795H63.5132V64.3865H85.4868V33.9795Z",
    fill: "#FFFAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48H40V112H107V48Z",
    fill: "#FFFAED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101 36H48V113H101V36Z",
    fill: "#FFFAED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.074 46.4395H91.0144V62.9057H103.074V46.4395Z",
    fill: "#EB6262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.399 51.967H96.1971V69.5997H107.399V51.967Z",
    fill: "#EB6262"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46H42V63H58V46Z",
    fill: "#EB6262"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48H40V69H53V48Z",
    fill: "#EB6262"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3107 68.4739H41.6005V74.0066H47.3107V68.4739Z",
    fill: "#EB6262"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.405 69.0823H101.694V112.609H107.405V69.0823Z",
    fill: "#EB6262"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107 96H96V117H107V96Z",
    fill: "#EB6262"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107 102H91V113H107V102Z",
    fill: "#EB6262"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106 108H85V113H106V108Z",
    fill: "#EB6262"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96H37V113H47V96Z",
    fill: "#EB6262"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102H40V113H53V102Z",
    fill: "#EB6262"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58 107H40V113H58V107Z",
    fill: "#EB6262"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6953 51.967H68.9851V57.373H74.6953V51.967Z",
    fill: "#EB6262"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0144 51.967H79.9998V57.373H91.0144V51.967Z",
    fill: "#EB6262"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52H37V114H42V52Z",
    fill: "#E03E4C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112 52H106V113H112V52Z",
    fill: "#E03E4C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.405 112.604H41.6005V118.009H107.405V112.604Z",
    fill: "#E03E4C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5633 35.3384H84.5486V40.9877H95.5633V35.3384Z",
    fill: "#E03E4C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2942 35.4653H53.2795V40.8712H64.2942V35.4653Z",
    fill: "#E03E4C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57 35H48V41H57V35Z",
    fill: "#E03E4C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8869 40.8662H44.3795V46.4395H49.8869V40.8662Z",
    fill: "#E03E4C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45 46H40V52H45V46Z",
    fill: "#E03E4C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101 35H92V41H101V35Z",
    fill: "#E03E4C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104.874 40.9878H99.3667V46.4394H104.874V40.9878Z",
    fill: "#E03E4C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M108.581 46.4597H103.074V51.9671H108.581V46.4597Z",
    fill: "#E03E4C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96 30H53V36H96V30Z",
    fill: "#E03E4C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7426 78.1548H54.0503V80.8577H67.7426V78.1548Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8278 78.1548H76.1355V80.8577H89.8278V78.1548Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6863 85.5994H64.994V88.3023H78.6863V85.5994Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3215 84.1438H53.817V86.8468H62.3215V84.1438Z",
    fill: "#F4A688"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0965 84.1438H81.592V86.8468H90.0965V84.1438Z",
    fill: "#F4A688"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9851 51.967H58.2747V57.373H68.9851V51.967Z",
    fill: "#FEF1D5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9997 51.967H74.6952V57.373H79.9997V51.967Z",
    fill: "#FEF1D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePomegranate);
export default __webpack_public_path__ + "static/media/ProfilePomegranate.51fd4def756a16e020c07508cb830488.svg";
export { ForwardRef as ReactComponent };